import React from 'react';
import { Calendar, StickyNote, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LogCommunicationForm } from './LogCommunicationForm';

interface QuickActionsProps {
  clientId: string;
  clientName: string;
}

export const QuickActions: React.FC<QuickActionsProps> = ({ clientId, clientName }) => {
  return (
    <div className="fixed bottom-0 inset-x-0 md:hidden z-50 bg-surface-0 border-t border-border px-4 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <div className="flex gap-2">
        <Button
          variant="default"
          size="sm"
          className="flex-1 gap-1.5 text-xs"
          disabled
          title="Coming soon"
        >
          <Calendar className="h-4 w-4" />
          Booking
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="flex-1 gap-1.5 text-xs"
          disabled
          title="Coming soon"
        >
          <StickyNote className="h-4 w-4" />
          Note
        </Button>
        <LogCommunicationForm
          clientId={clientId}
          trigger={
            <Button variant="outline" size="sm" className="flex-1 gap-1.5 text-xs">
              <MessageSquare className="h-4 w-4" />
              Comms
            </Button>
          }
        />
      </div>
    </div>
  );
};
